import { render } from "./CadastroModeloVeiculoTrator.vue?vue&type=template&id=088103b2"
import script from "./CadastroModeloVeiculoTrator.vue?vue&type=script&lang=ts"
export * from "./CadastroModeloVeiculoTrator.vue?vue&type=script&lang=ts"
script.render = render

export default script